import { render, staticRenderFns } from "./editPriority.vue?vue&type=template&id=be8e5fa2&"
import script from "./editPriority.vue?vue&type=script&lang=js&"
export * from "./editPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports